// @ts-nocheck
import { FormFieldPresentationPropsCommon } from "@insite/mobius/FormField";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import updateCssValue, { Operators } from "@toolkit/Framework/Common/Utilities/updateCssValue";
import { gridGapStyles, gridPresetGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface FormGridProps {
    gridContainer: GridContainerProps;
    innerGridContainer: GridContainerProps;
    formField?: FormFieldPresentationPropsCommon;
    title?: TypographyPresentationProps;
    labelSeparated?: TypographyPresentationProps;
    labelLink?: LinkPresentationProps;
}

const sharedGridProps: Partial<FormGridProps> = {
    title: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            font-size: ${pxToRem(18)};
            margin-top: 1.2em;
        `,
    },
    labelSeparated: {
        css: inlineSeparatorStyles({ spacing: pxToRem(16) }),
    },
    labelLink: {
        css: css`
            ${linkActionStyles()}
            vertical-align: middle;
        `,
    },
};

export const formGridProps: FormGridProps = {
    ...sharedGridProps,
    gridContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.base)}
        `,
    },
    innerGridContainer: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    theme.design.form.grid.base.horizontal.map(x => updateCssValue(x, Operators.Divide, 2)),
                    theme.design.form.grid.base.vertical,
                );
            }}
        `,
    },
};

export const formSmallGridProps: FormGridProps = {
    ...sharedGridProps,
    gridContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.small)}
        `,
    },
    innerGridContainer: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    theme.design.form.grid.small.horizontal.map(x => updateCssValue(x, Operators.Divide, 2)),
                    theme.design.form.grid.small.vertical,
                );
            }}
        `,
    },
    formField: {
        sizeVariant: "small",
    },
};
